import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const DocumentPlus = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 39 39'
    >
      <g clipPath='url(#clip0_iconDocument)'>
        <path
          d='M23.4355 0.773682H8.57813C6.16575 0.773682 4.20312 2.73631 4.20312 5.14868V33.732C4.20312 36.1444 6.16575 38.107 8.57813 38.107H29.4242C31.8366 38.107 33.7992 36.1444 33.7992 33.732V11.1903L23.4355 0.773682ZM24.247 5.72472L28.8327 10.3339H25.7053C24.9012 10.3339 24.247 9.67965 24.247 8.87553V5.72472ZM30.8825 33.732C30.8825 34.5361 30.2283 35.1904 29.4241 35.1904H8.57813C7.774 35.1904 7.11979 34.5361 7.11979 33.732V5.14868C7.11979 4.34456 7.774 3.69035 8.57813 3.69035H21.3305V8.87553C21.3305 11.2879 23.2931 13.2505 25.7055 13.2505H30.8825V33.732Z'
          fill={primaryColorToUse}
        />
        <g clipPath='url(#clip1_iconPlus)'>
          <path
            d='M24.7279 20.4959H20.2768V16.0484C20.2768 15.3444 19.7088 14.7737 19.0048 14.7737C18.3009 14.7737 17.7332 15.3444 17.7332 16.0487V20.4989H13.2799C12.5759 20.4989 12.0036 21.0697 12.0039 21.774C12.0036 22.1258 12.1458 22.4484 12.3761 22.6787C12.6067 22.9097 12.925 23.0555 13.2765 23.0555H17.7332V27.4996C17.7332 27.8517 17.8729 28.1705 18.1035 28.4006C18.3342 28.6312 18.6515 28.774 19.0036 28.774C19.7073 28.774 20.2768 28.2032 20.2768 27.4996V23.0552H24.7279C25.4319 23.0552 26.0027 22.4795 26.0024 21.7755C26.0021 21.0719 25.4313 20.4959 24.7279 20.4959Z'
            fill={primaryColorToUse}
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_iconDocument'>
          <rect
            width='100%'
            height='100%'
            fill={primaryColorToUse}
            transform='translate(0.333984 0.773682)'
          />
        </clipPath>
        <clipPath id='clip1_iconPlus'>
          <rect
            width='14'
            height='14'
            fill={primaryColorToUse}
            transform='translate(12.002 14.7737)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};
